import PropTypes from 'prop-types';
import { ResidentialIndicator } from '../enums/residential-indicator';

export const ResidentialIndicatorPropType = PropTypes.oneOf(Object.values(ResidentialIndicator));

/**
 * @typedef {(
 *   'Residential'|
 *   'Commercial'|
 *   'Unknown'|
 *   'U'|
 *   'C'|
 *   'R'
 * )} ResidentialIndicatorPropType
 */
